import React, { useEffect, useState } from 'react'
import {
  DdiContainer,
  DdiList,
  DdiOption,
  DdiSelector,
  DdiText,
  Flag,
} from './styles'

type Props = {
  'data-qa'?: string
  ddiOptions: DdiSelectorProps[]
  defaultDdiCode?: string
  disabled?: boolean
  onDdiChange: Function
}

const DDISelector: React.FC<Props> = (props: Props): JSX.Element => {
  const [currentDdi, setCurrentDdi] = useState(
    props.defaultDdiCode || props.ddiOptions[0]?.code,
  )
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)

  useEffect(() => {
    props.onDdiChange(currentDdi)
  }, [currentDdi, props.onDdiChange])

  const handleSelect = (code) => {
    setCurrentDdi(code)
    setIsDropdownOpen(false)
  }

  const handleDropdownToggle = () => {
    if (props.disabled) return
    setIsDropdownOpen(!isDropdownOpen)
  }

  const renderFlag = (flag) => {
    if (typeof flag === 'string') {
      return (
        <Flag>
          <img src={flag} alt="Flag" />
        </Flag>
      )
    } else if (React.isValidElement(flag)) {
      return <Flag>{flag}</Flag>
    }
    return null
  }

  const currentOption = props.ddiOptions.find(
    (option) => option.code === currentDdi,
  )

  return (
    <div>
      <DdiSelector
        onClick={handleDropdownToggle}
        className={`${props.disabled ? 'is-disabled' : ''}`}
        data-qa={`${props['data-qa']}-ddi-selector`}
      >
        {currentOption && (
          <DdiContainer>
            {renderFlag(currentOption.flag)}
            <DdiText>{currentOption.code}</DdiText>
          </DdiContainer>
        )}
      </DdiSelector>
      {isDropdownOpen && (
        <DdiList data-qa={`${props['data-qa']}-ddi-selector-dropdown`}>
          {props.ddiOptions.map((option) => (
            <DdiOption
              key={option.code}
              onClick={() => handleSelect(option.code)}
            >
              {renderFlag(option.flag)}
              <DdiText>{option.code}</DdiText>
            </DdiOption>
          ))}
        </DdiList>
      )}
    </div>
  )
}

export interface DdiSelectorProps {
  flag: string | JSX.Element
  code: string
}

export default DDISelector
